import AbstractAccordion from './AbstractAccordion'
import { shallowRef } from 'vue'
import SimplesComponent from '@/modules/common/common/components/insuranceAccordions/SimplesComponent.vue'

export default class AccordionSimple extends AbstractAccordion<
  string | { text: string; value: string }
> {
  component = shallowRef(SimplesComponent)

  constructor(attributes: Partial<AccordionSimple>) {
    super(attributes)
  }
}
